import React from "react"

const AppContext = React.createContext({
  blockUI: false,
  setBlockUI: () => {},
})

export default AppContext
